/** Date filter presets used by Wake-Up History */
export type DatePreset =
  'today' | 'yesterday' | '1week' | '2weeks' | '3weeks' | '4weeks' | 'all'

export const DATE_PRESET_LABELS: Record<DatePreset, string> = {
  today: 'Today',
  yesterday: 'Yesterday',
  '1week': '1 Week',
  '2weeks': '2 Weeks',
  '3weeks': '3 Weeks',
  '4weeks': '4 Weeks',
  all: 'All',
}

/** Number of days to look back for each preset (null = no limit) */
export const DATE_PRESET_DAYS: Record<DatePreset, number | null> = {
  today: 0,
  yesterday: 1,
  '1week': 7,
  '2weeks': 14,
  '3weeks': 21,
  '4weeks': 28,
  all: null,
}
